export const breakpoints = [
    // xs
    '375px', // s
    '768px', // m
    '1024px', // l
    '1440px', // xl
];
export const mediaQueries = {
    xs: `@media only screen and (max-width: calc(${breakpoints[0]} - 1px))`,
    s: `@media only screen and (min-width: ${breakpoints[0]})`,
    m: `@media only screen and (min-width: ${breakpoints[1]})`,
    l: `@media only screen and (min-width: ${breakpoints[2]})`,
    xl: `@media only screen and (min-width: ${breakpoints[3]})`,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnJlYWtwb2ludHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdGhlbWUvYnJlYWtwb2ludHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxDQUFDLE1BQU0sV0FBVyxHQUF5QjtJQUMvQyxLQUFLO0lBQ0wsT0FBTyxFQUFFLElBQUk7SUFDYixPQUFPLEVBQUUsSUFBSTtJQUNiLFFBQVEsRUFBRSxJQUFJO0lBQ2QsUUFBUSxFQUFFLEtBQUs7Q0FDaEIsQ0FBQztBQUVGLE1BQU0sQ0FBQyxNQUFNLFlBQVksR0FBMEI7SUFDakQsRUFBRSxFQUFFLDJDQUEyQyxXQUFXLENBQUMsQ0FBQyxDQUFDLFVBQVU7SUFDdkUsQ0FBQyxFQUFFLHNDQUFzQyxXQUFXLENBQUMsQ0FBQyxDQUFDLEdBQUc7SUFDMUQsQ0FBQyxFQUFFLHNDQUFzQyxXQUFXLENBQUMsQ0FBQyxDQUFDLEdBQUc7SUFDMUQsQ0FBQyxFQUFFLHNDQUFzQyxXQUFXLENBQUMsQ0FBQyxDQUFDLEdBQUc7SUFDMUQsRUFBRSxFQUFFLHNDQUFzQyxXQUFXLENBQUMsQ0FBQyxDQUFDLEdBQUc7Q0FDNUQsQ0FBQyJ9